import { useMemo, useState } from 'react';
import { useTranslations } from 'next-intl';
import { useUnit } from 'effector-react';
import classNames from 'classnames';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { BillingAddonCode } from '@nx-frontend/shared/types';
import { BillingAddon } from '@nx-frontend/shared/types/paywall-types';
import { PaywallAddonCardWrapper } from './paywall-addon-card-wrapper';
import { $paywallStore } from './store';

interface PaywallAddonsProps {
  isOpen?: boolean;
}

export const PaywallAddons = (props: PaywallAddonsProps) => {
  const [isOpen, setIsOpen] = useState(props.isOpen ?? false);
  const [paywallState] = useUnit([$paywallStore]);
  const t = useTranslations('features');

  const handleToggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const addonsToShow = useMemo(() => {
    return paywallState.addons;
  }, [paywallState.addons]);

  const pluginsList = (
    <div className={classNames('overflow-hidden')}>
      <div
        className={classNames('duration-300', {
          'h-0 opacity-0': !isOpen,
          'h-[324px] opacity-100 mt-3': isOpen, // 424px
        })}
      >
        <div className={classNames('grid grid-cols-1 md:grid-cols-2 gap-2 px-[3px]')}>
          {addonsToShow.map((addon, i) => {
            const addons = paywallState.selectedAddons as Record<BillingAddonCode, BillingAddon>;
            const addonCardProps = {
              ...addon,
              price: addon.pricePerMonth,
            };
            return <PaywallAddonCardWrapper key={i} {...addonCardProps} selected={!!addons[addon.code]} />;
          })}
        </div>
      </div>
    </div>
  );

  if (paywallState.mode === 'addons') {
    return <div>{pluginsList}</div>;
  }

  return (
    <div className="paywall__addons border border-neutral-200 p-5 rounded-[10px] bg-white">
      <div
        className="flex items-center text-lg font-semibold text-neutral-800 cursor-pointer px-1"
        onClick={handleToggleOpen}
      >
        <Icon icon={IconsMap.PUZZLE} className="w-[20px] mr-2" />
        <span className="flex-1">{t('paywall.choose_addon')}</span>
        <Icon
          icon={IconsMap.ARROW_2_DOWN}
          className={classNames('w-[16px] duration-200', {
            'rotate-180': isOpen,
          })}
        />
      </div>
      {pluginsList}
    </div>
  );
};
